import React from "react";
import { useField } from "formik";
import { InputPropsWithoutRef } from "react-html-props";
import TextInput from "./TextInput";

const PlainTextInputField = (props: Props) => {
  const { label, helpText, hiddenLabel, ...otherProps } = props;
  const [field, meta] = useField<string>(props);

  const showError = Boolean(meta.touched && meta.error);

  const value = field.value || "";

  return (
    <TextInput {...field} {...otherProps} value={value} error={showError} />
  );
};

interface Props extends InputPropsWithoutRef {
  label?: string;
  name: string;
  helpText?: string;
  hiddenLabel?: boolean;
}

export default PlainTextInputField;
